import React from 'react';
import styled, { css } from 'styled-components';
import { alpha } from '@mui/material/styles';
import {
  Typography as MuiTypography,
  Button as MuiButton,
} from '@mui/material';

import { Icon } from 'components/ui';
import { CircularProgress } from '@mui/material';

const Button = styled(
  ({
    title,
    className,
    icon,
    loading,
    variant = 'outlined',
    dataId = 'button',
    iconType = 'far',
    textVariant = 'h5',
    ...props
  }) => (
    <MuiButton
      data-id={dataId}
      size="small"
      variant={variant}
      className={className}
      classes={{ disabled: 'disabled' }}
      {...props}
    >
      {/*{icon && <Icon icon={icon} className="icon" mr={10} />}*/}
      {/*<MuiTypography variant="h5">{title}</MuiTypography>*/}
      {!loading ? (
        <div className="content-wrap">
          {icon && (
            <Icon
              icon={icon || 'plus'}
              className="icon"
              type={iconType}
              mr={10}
            />
          )}
          <MuiTypography variant={textVariant} color="inherit">
            {title}
          </MuiTypography>
        </div>
      ) : (
        <CircularProgress size={20} />
      )}
    </MuiButton>
  )
)`
  && {
    height: 40px;
    ${({ isDefaultStyle }) =>
      !isDefaultStyle &&
      css`
        background-color: ${(props) =>
          props.color === 'error'
            ? props.theme.palette.error.light
            : props.theme.palette.primary.light};
        border: none;
        color: ${(props) =>
          props.color === 'error'
            ? props.theme.palette.error.main
            : props.theme.palette.primary.main};
      `}

    &.disabled {
      color: ${(props) => props.theme.palette.grey[400]};
      background-color: ${(props) => props.theme.palette.grey[200]};
      border: none;

      .MuiTypography-root {
        color: ${(props) => props.theme.palette.grey[400]};
      }
    }

    &:hover {
      background-color: ${(props) =>
        props.color === 'error'
          ? props.theme.palette.error.main
          : props.theme.palette.primary.main};

      .MuiTypography-root {
        color: ${(props) => props.theme.palette.common.white};
      }
      .icon {
        color: ${(props) => props.theme.palette.common.white};
      }
    }

    .MuiTypography-root {
      color: ${(props) =>
        props.color === 'error'
          ? props.theme.palette.error.main
          : props.theme.palette.primary.main};
      text-transform: none;
    }

    .icon {
      margin-right: 10px;
      font-size: 16px;
    }

    .content-wrap {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }
`;

export default Button;
